import { SupplierService } from "../../../http/services/supplier";
import { SET_SUPPLIERS, SET_SUPPLIER } from "../../mutations.type";
import {
  FETCH_SUPPLIERS,
  FETCH_SUPPLIER,
  CREATE_SUPPLIER,
  UPDATE_SUPPLIER,
  DELETE_SUPPLIER
} from "../../actions.type";

export default {
  async [FETCH_SUPPLIERS](context) {
    const resp = await SupplierService.getAll();
    context.commit(SET_SUPPLIERS, resp.data.suppliers);
  },
  async [FETCH_SUPPLIER](context, id) {
    const { data } = await SupplierService.get(id);
    context.commit(SET_SUPPLIER, data.supplier);
  },
  async [CREATE_SUPPLIER](context, newSupplier) {
    await SupplierService.create(newSupplier);
  },
  async [UPDATE_SUPPLIER](context, selectedSupplier) {
    await SupplierService.update(selectedSupplier);
  },
  async [DELETE_SUPPLIER](context, selectedSupplier) {
    await SupplierService.delete(selectedSupplier);
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/supplier/actions.js